import React from 'react'
import PropTypes from 'prop-types'
import { defaultTableRowRenderer } from 'react-virtualized'
import { useDrag } from 'react-dnd'
import isFunction from 'lodash/isFunction'
import { mergeProps } from 'src/util'
import { NavLink } from 'src/components/router'
import styles from './TableRow.scss'

function TableRowContainer(props) {
  return props.dndSource ? <DraggableTableRow {...props} /> : <TableRow {...props} />
}

TableRowContainer.propTypes = DraggableTableRow.propTypes

const TableRow = ({ to, rowData, ...props }) => {
  const Component = to ? NavLink : 'div'

  return <Component to={to} {...defaultTableRowRenderer({ rowData, ...props }).props} />
}

TableRow.propTypes = {
  to: PropTypes.string,
  rowData: PropTypes.any,
}

function DraggableTableRow({ dndSource, rowData, ...props }) {
  // initialize drag behaviour
  const [isDragging, ref] = useDrag({
    item: { data: rowData, type: isFunction(dndSource) ? dndSource(rowData) : dndSource },
    collect: monitor => monitor.isDragging(),
  })

  return (
    <span ref={ref}>
      <TableRow
        {...mergeProps()(props, {
          rowData,
          className: { [styles.draggable]: !!dndSource, [styles.dragging]: isDragging },
        })}
      />
    </span>
  )
}

DraggableTableRow.propTypes = {
  ...TableRow.propTypes,
  dndSource: PropTypes.elementType,
}

export default TableRowContainer
